module.exports = __webpack_public_path__ + "img/background.97e79ad0.png";